import { Suspense, ReactNode } from 'react';
import MainSpinner from '../components/Spinner/large';
import RouteErrorBoundary from './RouteErrorBoundary';

interface SuspenseRouteProps {
  children: ReactNode;
}

export default function SuspenseRoute({ children }: SuspenseRouteProps) {
  return (
    <RouteErrorBoundary>
      <Suspense fallback={<MainSpinner />}>
        {children}
      </Suspense>
    </RouteErrorBoundary>
  );
}
